export const userIsSeeker = (user) => (user?.user_type === 'seeker');
export const userIsAdvisor = (user) => (user?.user_type === 'advisor');
